export default {
  namespaced: true,
  state: {
    scrolledFromTop: 0,
  },
  getters: {
    getScrolledFromTop: (state) => state.scrolledFromTop,
  },
  mutations: {
    setScrolledFromTop: (state, value) => (state.scrolledFromTop = value),
  },
  actions: {},
};
